// there are issues with this; formatting for million removes decimal point
// anything over 100 million doesn't have special handling - probably not a real world problem
// also, this should be called formatNumberForFourDigits

export const formatNumberForThreeDigits = number => {
  let retVal = number.toString()
  if (retVal > 9999 && retVal < 100000) {
    retVal =
      Math.floor(retVal / 1000)
        .toFixed(0)
        .toString() + 'k+'
  } else if (retVal >= 100000 && retVal < 1000000) {
    retVal =
      Math.floor(retVal / 1000)
        .toFixed(0)
        .toString() + 'k'
  } else if (retVal >= 1000000 && retVal < 10000000) {
    retVal =
      Math.floor(retVal / 1000000)
        .toFixed(1)
        .toString() + 'm'
  } else if (retVal >= 10000000 && retVal < 100000000) {
    retVal =
      Math.floor(retVal / 1000000)
        .toFixed(0)
        .toString() + 'm+'
  } else if (retVal >= 100000000) {
    retVal =
      Math.floor(retVal / 1000000)
        .toFixed(0)
        .toString() + 'm'
  }

  return retVal
}



// WEBPACK FOOTER //
// ./src/utils/numbers.js